module.exports = __webpack_public_path__ + "img/tu06.59d29cba.png";